import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { KpiList } from 'src/app/core/models/insight-configuration.model';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-kpi-selection-validation-popup',
  templateUrl: './kpi-selection-validation-popup.component.html',
  styleUrls: ['./kpi-selection-validation-popup.component.scss']
})
export class KpiSelectionValidationPopupComponent implements OnInit {

  public configuredKpiList : KpiList[];
  public unsubscribe = new Subject<void>();

  constructor(
    public modalRef: BsModalRef,
    public store: Store
  ) {
  }

  ngOnInit(): void {
    this.getConfiguredKpiList();
  }

  public getConfiguredKpiList() {
    // Get the configured KPI list to show in the modal
    this.store.select(state => state.configurations.kpi.configuredKpiList).subscribe(configuredKpis => {
      this.configuredKpiList = configuredKpis;
    })
  }
  
  public onCloseButtonClick() : void {
    this.modalRef.hide();
  }
}
